module.exports = __webpack_public_path__ + "static/img/meitanqiye.6f0ffca4.png";